import { MAX_TIME_IDLE_IN_MS } from '@/constants'

export function initInactivityTracker(onIdle: () => void): void {
  let timeoutId: number | undefined

  const resetTimer = (): void => {
    // Clear existing timer
    if (timeoutId) {
      window.clearTimeout(timeoutId)
    }

    // Set a new timer
    timeoutId = window.setTimeout(() => {
      onIdle()
      window.location.href = '/'
    }, MAX_TIME_IDLE_IN_MS)
  }

  // Events that signify "activity"
  const activityEvents: string[] = [
    'mousedown',
    'mousemove',
    'keypress',
    'scroll',
    'touchstart'
  ]

  // Attach event listeners to the window
  activityEvents.forEach(event => {
    window.addEventListener(event, resetTimer, { passive: true })
  })

  // Initialize the timer on script load
  resetTimer()
}
